import { DOMAIN } from '../constants/cookies';

function cookieDomainHelper(web4Host) {
  if (web4Host.includes(DOMAIN.LOCAL)) {
    return DOMAIN.LOCAL;
  }
  return DOMAIN.TRADEREV;
}

export default cookieDomainHelper;
